// On the backend id's start from 1
const colors = ['#CB2B3E', '#2AAD27', '#2A81CB', '#FFD326'];

export default colors;
